export default `id
name
locked
active
deleted
templateCopyOn
templateUpdatedOn
signingTemplateId
qualificationStepType`
